import { getBaseUrl } from '../utils/getBaseUrl'; 

const baseURL = getBaseUrl() + 'post/';

export const DeletePost = async (postId) => {
    try {
        await fetch(baseURL + 'delete', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: postId
        });
        return "Post deleted";
    } catch (error) {
        console.error('Error deleting the post:', error);
    }
};

export const GetAllPost = async (categoryPk = 0, page = 1, pageSize = 10) => {
    try {
        const response = await fetch(
            `${baseURL}getall?categoryPk=${categoryPk}&page=${page}&pageSize=${pageSize}`
        );

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const jsonData = await response.json();
        return jsonData; // { posts: [...], totalCount: N }
    } catch (error) {
        console.error('Error fetching posts:', error);
        return { posts: [], totalCount: 0 };
    }
};


export const AddPost = async (postBody) => {
    try {
        await fetch(baseURL + 'add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: postBody
        });
        return "Post added";
    } catch (error) {
        console.error('Error adding post:', error);
    }
};

export const GetPostById = async (postId) => {
    try {
        const response = await fetch(baseURL + `getbypk?postPk=${postId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching post by ID:', error);
    }
};
